import React from "react";
import * as _ from "lodash";
import ColumnConfiguration from "./columnConfiguration";
import { AgGridReact } from "@ag-grid-community/react";
import { ColDef, RowDragEndEvent } from "@ag-grid-community/all-modules";
import columnBuilder from "./columnBuilder";
import { Button } from "react-bootstrap";
import './columnConfigurationPanel.scss';
import defaultGridOptions from "./defaultGridOptions";
import { localizeCommon as localize } from "features/localization/localizeService";


export interface ColumnConfigurationPanelProps {
    columns: ColumnConfiguration[];
    selectedColumns: ColumnConfiguration[];
    onColumnsChanged(columns: ColumnConfiguration[]): void;
};

class PanelState {
    showAvailable: boolean = false;
}

export default class ColumnConfigurationPanel extends React.Component<ColumnConfigurationPanelProps, PanelState> {

    state = {
        ...new PanelState()
    }

    private listColumns(): ColumnConfiguration[] {
        return this.state.showAvailable
            ? _.differenceBy(this.props.columns, this.props.selectedColumns, c => c.id)
            : _.intersectionBy(this.props.selectedColumns, this.props.columns, c => c.id);
    }

    private setShowAvailable(value: boolean) {
        this.setState({showAvailable: value});
    }

    private addColumn(column: ColumnConfiguration) {
        this.props.onColumnsChanged([...this.props.selectedColumns, column]);
    }

    private removeColumn(column: ColumnConfiguration) {
        this.props.onColumnsChanged(this.props.selectedColumns
            .filter(c => c.id !== column.id));
    }

    private getColumnDefinitions(): ColDef[] {
        //TODO: check if we can fix this. There was some weirdness around old versions of ag-grid
        /* eslint-disable unicorn/no-this-assignment */
        const _this = this;
        return columnBuilder.collection(builder => [ 
            builder.for('', 'displayName')
                .asDraggable(!this.state.showAvailable),
            builder.for('', 'description'),
            builder.for('', 'action')
                .withWidth(40)
                .withCellRenderer<ColumnConfiguration>(params => (
                    _this.state.showAvailable
                        ? <button className="link-button" onClick={() => this.addColumn(params.node.data)}>
                            <i className="material-icons">add_circle</i>
                        </button>
                        : <button className="link-button" onClick={() => this.removeColumn(params.node.data)}>
                            <i className="material-icons danger">remove_circle</i>
                        </button>
                ))
        ]);
    }

    private handleRowDragEnd(event: RowDragEndEvent) {
        const column = event.node.data;
        const newArray = this.props.selectedColumns
            .filter(m => m.id !== column.id);
        //If the user drags off the bottom, overIndex is -1
        const newIndex = event.overIndex === -1
            ? newArray.length
            : event.overIndex;
        newArray.splice(newIndex, 0, column);
        
        this.props.onColumnsChanged(newArray);
    }

    render() {

        return (
            <div className="column-configuration-panel">
                <ul className="nav nav-pills nav-fill">
                    <li className="nav-item">
                        <Button active={!this.state.showAvailable}
                            onClick={() => this.setShowAvailable(false)}
                            variant="link"
                            className="nav-link">
                                {localize("ColumnConfigurationPanel_Toggle_Selected")}
                        </Button>
                    </li>
                    <li className="nav-item">
                        <Button active={this.state.showAvailable}
                            onClick={() => this.setShowAvailable(true)}
                            variant="link"
                            className="nav-link">
                                {localize("ColumnConfigurationPanel_Toggle_Available")}
                        </Button>
                    </li>
                </ul>
                <div className="ag-theme-alpine" style={{ width: "100%" }}>
                    <AgGridReact
                        {...defaultGridOptions}
                        columnDefs={this.getColumnDefinitions()}
                        rowData={this.listColumns()}
                        rowDragManaged
                        //If the user drags off the grid, we need to handle that
                        onRowDragLeave={(ev) => this.handleRowDragEnd(ev)}
                        onRowDragEnd={(ev) => this.handleRowDragEnd(ev)}
                        headerHeight={0}
                        domLayout="autoHeight"
                        getRowId={params => params.data.id}

                        onRowDataChanged={params => params.api.sizeColumnsToFit()}
                        onGridReady={params => params.api.sizeColumnsToFit()}
                    />
                </div>
            </div>
        );
    }
}
